import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Tab } from 'semantic-ui-react';
import ReservationSummary from "../ReservationSummary";
import FolioOwnerSummary from "../FolioOwnerSummary";
import FolioDetails from "../FolioDetails";
import FolioOwnerDetails from "../FolioOwnerDetails";
import { useTextResources } from '../../language';
import ShopItems from "../ShopItems";
import "./style.css";

const FolioSideTabs = ({reservationID: initialResId, hotelID, currency, onReservation, onOwner, includeTax}) => {
    const text = useTextResources();
    const [owner, setOwner] = useState()
    const [folioId, setFolioId] = useState()
    const [isNoRoomFolio ,setIsNoRoomFolio] = useState(false)
    const [noRoomFolio, setNoRoomFolio] = useState()
    const [noRoomOwner, setNoRoomOwner] = useState()
    const [reservationID, setReservationID] = useState(initialResId)

    useEffect(() => {
        window.addEventListener("message", function (event) {
            if (event.data && event.data.eventType === "FolioDataLoaded") {
                if(!owner || (owner && owner.id != event.data.ownerId || owner.data.ownerTypeId != owner.typeId)){
                    setOwner({id: event.data.ownerId, typeId: event.data.ownerTypeId})
                }
                setReservationID(event.data.reservationId)
            }
            if (event.data && event.data.eventType === "FolioDetails") {
                setFolioId(event.data.folioId)
            }
            if (event.data && event.data.eventType === "NoRoomFolio") {
                setIsNoRoomFolio(event.data.noRoomFolio)
                if (event.data.currentOwner) {
                    setNoRoomOwner(prev=>({...prev, ...event.data.currentOwner}))
                }
                if (event.data.currentFolio) {
                    setNoRoomFolio(prev=>({...prev, ...event.data.currentFolio}))
                }
            }
        })
    }, [])

    const folioDetailsPane = {
        menuItem: text("FolioDetails"),
        pane: <Tab.Pane key={"1"}>
                <FolioOwnerSummary 
                    OwnerId={owner && owner.id} 
                    OwnerTypeId={owner && owner.typeId} 
                    HotelID={hotelID} 
                    OnOwner={onOwner}
                    ReservationID={reservationID}
                />
                <div className="fake-space"></div>
                <ReservationSummary
                    ReservationID={reservationID}
                    HotelID={hotelID} 
                    Currency={currency} 
                    onReservation={onReservation}
                />
            </Tab.Pane>
    }

    const noRoomFolioPane = {
        menuItem: text("FolioDetails"),
        pane:   <Tab.Pane key={"2"}>
                    <FolioDetails 
                        currentNoRoomFolio={noRoomFolio}
                        onUpdate={setNoRoomFolio}
                    />
                    <FolioOwnerDetails
                        currentNoRoomFolio={noRoomFolio}
                        currentNoRoomOwner={noRoomOwner}
                     />
                </Tab.Pane>
    }

    const optimaShopPane = {
        menuItem: text("Shop"),
        pane:   <Tab.Pane key={"3"}>
                    <ShopItems 
                        currency={currency}
                        hotelID={hotelID} 
                        includeTax={includeTax}
                        folioId={folioId}
                    />
                </Tab.Pane>
    }

    const gettabPanes = ()=>{
        const isSelfie = window.location.search.includes("IsSelfie=1")
        if (reservationID) {
            return isSelfie?[folioDetailsPane]:[folioDetailsPane, optimaShopPane]
        } else {
            if (isNoRoomFolio) {
                if (isSelfie) {
                    return [noRoomFolioPane]
                } else {
                    return folioId?[noRoomFolioPane, optimaShopPane]:[noRoomFolioPane]
                }
                
            } else {
                return isSelfie?[]:[optimaShopPane]
            }
        }
    }
        

    return (
        <div>
            <Tab renderActiveOnly={false} menu={{ secondary: true, pointing: true }} panes={gettabPanes()} />
        </div>
    )
}

FolioSideTabs.propTypes = {
    reservationID: PropTypes.number,
    hotelID: PropTypes.number,
    currency: PropTypes.number,
    onReservation: PropTypes.func,
    onReservationLoaded: PropTypes.func,
    onOwner: PropTypes.func,
    includeTax: PropTypes.bool
}

export default FolioSideTabs;